import { ENDCAP_ATTACH_ACCESSORY } from "../lib/types";

export const attachAccessory = ( endcapPosition, accessory, row ) => dispatch => {
  dispatch({
    type: ENDCAP_ATTACH_ACCESSORY,
    payload: {
      endcapPosition,
      accessory,
      row
    }
  });
};



// WEBPACK FOOTER //
// ./src/actions/endcap-actions.js